import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create(() => ({
  container: {
    // Stripe's element sizes itself (iframe on web, native view on iOS/Android); this
    // only bounds the horizontal extent so a long message wraps inside the row.
    width: '100%',
  },
  hidden: {
    // `opacity: 0` keeps the element loading (display:none would not);
    // `height: 0` keeps it out of layout; `pointerEvents: 'none'` keeps the
    // hidden copy from ever taking a tap. Used to pre-mount both selected and
    // unselected Stripe instances so toggling `selected` doesn't rebuild the
    // element (which is what causes the layout shift and color lag).
    height: 0,
    overflow: 'hidden',
    opacity: 0,
    pointerEvents: 'none',
  },
}));
